/**
 * Hotspot Product Interaction Handler
 * Handles hover effects and click behavior for product hotspots
 */

if (!window.MMAHotspotProductHandlerClass) {
window.MMAHotspotProductHandlerClass = class HotspotProductHandler {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Find all product hotspots and attach event listeners directly to them
    const productHotspots = document.querySelectorAll('.hotspot--product');
    
    productHotspots.forEach(hotspot => {
      if (hotspot.dataset.hotspotHandlerBound === 'true') return;
      hotspot.dataset.hotspotHandlerBound = 'true';

      const productId = hotspot.dataset.productId;
      if (!productId) return;

      // Attach hover events directly to this hotspot
      hotspot.addEventListener('mouseenter', () => {
        this.highlightProductCard(productId);
      });

      hotspot.addEventListener('mouseleave', () => {
        this.unhighlightProductCard(productId);
      });

      // Attach click event directly to this hotspot
      hotspot.addEventListener('click', (event) => {
        // Prevent default modal behavior
        event.preventDefault();
        event.stopPropagation();

        // Open product URL in new window
        const productUrl = hotspot.href;
        if (productUrl) {
          window.open(productUrl, '_blank', 'noopener,noreferrer');
        }
      });
    });
  }

  highlightProductCard(productId) {
    const productCard = document.querySelector(`.hotspot-product-card[data-product-id="${productId}"]`);
    if (productCard) {
      productCard.classList.add('hotspot-product-card--highlighted');
    }
  }

  unhighlightProductCard(productId) {
    const productCard = document.querySelector(`.hotspot-product-card[data-product-id="${productId}"]`);
    if (productCard) {
      productCard.classList.remove('hotspot-product-card--highlighted');
    }
  }
}
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.MMAHotspotProductHandler = new window.MMAHotspotProductHandlerClass();
});

// Also initialize for dynamically loaded content
document.addEventListener('shopify:section:load', () => {
  window.MMAHotspotProductHandler = new window.MMAHotspotProductHandlerClass();
});
